import React from "react"
import { View, ScrollView } from "react-native"

import TextM from "@common/components/text/TextM"
import { SelectInputM } from "../../student/account/onboarding/SelectInputM"
import { studentClasses } from "@data/constants/formConstants"
import LinkTextM from "@common/components/text/LinkTextM"
import { theme } from "@common/theme/theme"

const StudentInfoStep = (props) => {
    const { control, user, hoursPerWeek } = props

    const fullname = `${user?.firstname ?? ""} ${user?.lastname ?? ""}`.trim()

    return (
        <ScrollView style={{ width: "100%" }} contentContainerStyle={{ paddingHorizontal: 10, paddingBottom: 100 }}>
            <TextM
                color={theme.colors.primary}
                wrap
                fontWeight={"Medium"}
                fontSize={12}
                style={{ marginBottom: 4 }}
            >
                Prénom Nom
            </TextM>
            <View
                style={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    borderRadius: theme.roundness,
                    paddingVertical: 10,
                    paddingHorizontal: 15,
                    marginTop: 2,
                    borderWidth: 1,
                    borderColor: theme.colors.lightMore,
                    backgroundColor: theme.colors.lighter,
                    minHeight: 40,
                    marginBottom: 18,
                }}
            >
                <TextM color={theme.colors.grey} fontWeight="Regular" fontSize={14} wrap style={{ flex: 1 }}>
                    {fullname}
                </TextM>
            </View>

            <SelectInputM
                control={control}
                name="student_class"
                options={studentClasses?.map((c) => ({ label: c, value: c }))}
                label="Classe"
                style={{ width: "100%", marginBottom: 18 }}
                onSelect={() => { }}
            />

            <TextM color={theme.colors.primary}
                wrap
                fontWeight={"Medium"}
                fontSize={12}
                style={{ marginBottom: 4 }}>Nombre d&apos;heures par semaine</TextM>
            <View
                style={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    borderRadius: theme.roundness,
                    paddingVertical: 10,
                    paddingHorizontal: 15,
                    marginTop: 2,
                    borderWidth: 1,
                    borderColor: theme.colors.lightMore,
                    backgroundColor: theme.colors.lighter,
                    minHeight: 40,
                }}
            >
                <TextM color={theme.colors.grey} fontWeight="Regular" fontSize={14} wrap style={{ flex: 1 }}>
                    {hoursPerWeek} heures
                </TextM>
            </View>
            <TextM color={theme.colors.light} style={{ marginTop: 14 }} fontSize={12} wrap>
                Si vous souhaitez augmenter le nombre d&apos;heures par semaine, <LinkTextM url={user?.support_whatsapp_url}
                    style={{ color: theme.colors.link }}>contactez le support Masteur</LinkTextM>
            </TextM>
        </ScrollView>
    )
}

export default StudentInfoStep
